<template>
  <div>
    <!-- Profile Icon Button -->
    <button
        @click="toggleDrawer"
        class="btn btn-outline-light btn-sm profile-toggle"
        :class="{ 'active': isDrawerOpen }"
    >
      <img
          src="https://driqq8crwypb5.cloudfront.net/Public_Website_Images/images/profiledesign.png"
          alt="Profile"
          class="profile-icon-img"
      />
    </button>

    <!-- Drawer Overlay -->
    <Transition name="fade">
      <div
          v-if="isDrawerOpen"
          class="drawer-overlay"
          @click="closeDrawer"
      ></div>
    </Transition>

    <!-- Drawer -->
    <Transition name="slide-left">
      <div v-if="isDrawerOpen" class="profile-drawer">
        <!-- Scrollable Content -->
        <div class="drawer-content modern-scrollbar">
          <!-- Profile Section -->
          <div class="accordion-section">
            <button @click="toggleSection('profile')" class="accordion-header">
              <div class="header-left">
                <img src="https://driqq8crwypb5.cloudfront.net/Public_Website_Images/images/icons/Profile.png"
                     class="section-icon" alt="Profile" />
                <span>Profile</span>
              </div>
              <i class="fas fa-chevron-down" :class="{ 'rotated': openSections.profile }"></i>
            </button>
            <Transition name="expand">
              <div v-if="openSections.profile" class="accordion-content">
                <div class="profile-info">
                  <p class="login-text">The last login was on {{ lastLoginDate }}</p>
                </div>
              </div>
            </Transition>
          </div>

          <!-- Quick Actions Section -->
          <div class="accordion-section">
            <button @click="toggleSection('quickActions')" class="accordion-header">
              <div class="header-left">
                <img src="https://driqq8crwypb5.cloudfront.net/Public_Website_Images/images/icons/Quick Guide.png"
                     class="section-icon" alt="Quick Guide" />
                <span>Quick Guide</span>
              </div>
              <i class="fas fa-chevron-down" :class="{ 'rotated': openSections.quickActions }"></i>
            </button>
            <Transition name="expand">
              <div v-if="openSections.quickActions" class="accordion-content">
                <div class="quick-actions-content">
                  <UserGuide />
                </div>
              </div>
            </Transition>
          </div>

          <!-- Subscriptions Section -->
          <div class="accordion-section">
            <button @click="toggleSection('subscriptions')" class="accordion-header">
              <div class="header-left">
                <img src="https://driqq8crwypb5.cloudfront.net/Public_Website_Images/images/icons/Commodity Overview&Subscriptions.png"
                     class="section-icon" alt="Subscriptions" />
                <span>Subscriptions</span>
              </div>
              <i class="fas fa-chevron-down" :class="{ 'rotated': openSections.subscriptions }"></i>
            </button>
            <Transition name="expand">
              <div v-if="openSections.subscriptions" class="accordion-content">
                <MySubscriptions />
              </div>
            </Transition>
          </div>

          <!-- Notifications Section -->
          <div class="accordion-section">
            <button @click="toggleSection('notifications')" class="accordion-header">
              <div class="header-left">
                <img src="https://driqq8crwypb5.cloudfront.net/Public_Website_Images/images/icons/Notification.png"
                     class="section-icon" alt="Notifications" />
                <span>Notifications</span>
                <span v-if="unreadNotificationsCount > 0" class="notification-badge">
                  {{ unreadNotificationsCount }}
                </span>
              </div>
              <i class="fas fa-chevron-down" :class="{ 'rotated': openSections.notifications }"></i>
            </button>
            <Transition name="expand">
              <div v-if="openSections.notifications" class="accordion-content">

                <!-- Element Filter Bar -->
                <div v-if="availableElements.length" class="element-filter-bar">
                  <div class="custom-select" :class="{ open: isFilterOpen }" ref="filterDropdown">
                    <button class="custom-select-trigger" @click="isFilterOpen = !isFilterOpen">
                      <span>{{ activeElementFilter ? elementInfo(activeElementFilter) || activeElementFilter : 'All elements' }}</span>
                      <i class="fas fa-chevron-down select-chevron"></i>
                    </button>
                    <div class="custom-select-dropdown">
                      <div
                          class="custom-select-option"
                          :class="{ active: activeElementFilter === null }"
                          @click="activeElementFilter = null; isFilterOpen = false"
                      >
                        <span class="option-name">All elements</span>
                      </div>
                      <div
                          v-for="el in availableElements"
                          :key="el"
                          class="custom-select-option"
                          :class="{ active: activeElementFilter === el }"
                          @click="activeElementFilter = el; isFilterOpen = false"
                      >
<!--                        <span class="option-symbol">{{ el }}</span>-->
                        <span class="option-name">{{ elementInfo(el) || el }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="filteredNotifications?.length" class="notifications-list-wrapper modern-scrollbar">
                  <div v-if="filteredNotifications?.length" class="notifications-list">
                  <div
                      v-for="notification in filteredNotifications"
                      :key="notification.id"
                      class="notification-item"
                      @click="goToProfile(notification)"
                  >
                    <div class="notification-icon">
                      <div class="text-center icon icon-shape border-radius-2xl">
                        <img
                            style="width: 40px;"
                            :src="notification.imageUrl || 'https://driqq8crwypb5.cloudfront.net/Public_Website_Images/images/new-logo.png'"
                        />
                      </div>
                    </div>
                    <div class="notification-content">
                      <h6>{{ notification.name }}</h6>
                      <p class="notification-description">
                        {{ getNotificationMessage(notification) }}
                      </p>
                    </div>
                    <!-- Email Icon -->
                    <div class="notification-email-icon" @click.stop>
                      <i class="fas fa-envelope"></i>
                    </div>
                    <!-- Dismiss Icon -->
                    <button class="notification-dismiss-icon" @click.stop="dismissNotification(notification.id)">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
                </div>
                <div v-else class="empty-state">
                  <p>No new notifications.</p>
                </div>

              </div>
            </Transition>
          </div>

        </div>
        <!-- Sticky Logout Button -->
        <div class="drawer-logout">
          <a
              href="javascript:;"
              class="logout-btn"
              @click="invalidateAuthorization"
          >
            <img src="https://driqq8crwypb5.cloudfront.net/Public_Website_Images/images/icons/Log out.png"
                 class="section-icon" alt="Logout" />
            <span>Logout</span>
          </a>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { nextTick } from 'vue';
import moment from 'moment';
import MySubscriptions from '../HomePage/MySubscriptions.vue';
import UserGuide from '../HomePage/UserGuide.vue';
import { elementInfo } from '../../utils/index';
import { logout } from '../../composables/auth';

import {
  NOTIFICATIONS,
  getNotifications
} from '../../composables/subscription';
import {
  openNotification,
  dismissNotification,
  getNotificationMessage,
  ASSET_PROFILE_TYPE,
  COMPANY_PROFILE_TYPE,
  COST_SERVICE_TYPE,
  COUNTRY_PROFILE_TYPE,
  SUBSCRIPTION_FILES_PROFILE_TYPE,
} from '../../composables/notification';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { ROUTES } from '../../routes/names';

const router = useRouter();
const { t } = useI18n();
const isDrawerOpen = ref(false);
const openSections = ref({
  profile: false,
  quickActions: false,
  subscriptions: false,
  notifications: false
});
const activeElementFilter = ref(null);
const isFilterOpen = ref(false);
const filterDropdown = ref(null);

// inside onMounted, add:
document.addEventListener('click', (e) => {
  if (filterDropdown.value && !filterDropdown.value.contains(e.target)) {
    isFilterOpen.value = false;
  }
});

// Computed properties for dynamic data
const lastLoginDate = computed(() => {
  return moment(NOTIFICATIONS.value?.lastLogin).format("YYYY-MM-DD");
});

const notifications = computed(() => {
  return NOTIFICATIONS.value || [];
});

const unreadNotifications = computed(() => {
  return notifications.value.filter(n => !n.isRead);
});

const unreadNotificationsCount = computed(() => {
  return unreadNotifications.value.length;
});

// Methods
const toggleDrawer = () => {
  isDrawerOpen.value = !isDrawerOpen.value;
};

const closeDrawer = () => {
  isDrawerOpen.value = false;
};

const toggleSection = (section) => {
  openSections.value[section] = !openSections.value[section];
};

// Updated notification click handler with proper routing from old system
const goToProfile = (nth) => {
  let element = '';
  if (nth?.commodities?.length > 0) {
    element = nth?.commodities[0];
  }
  let ROUTE_NAME;
  if (nth.type === ASSET_PROFILE_TYPE) ROUTE_NAME = ROUTES.ASSET_PROFILE.name;
  if (nth.type === COMPANY_PROFILE_TYPE)
    ROUTE_NAME = ROUTES.COMPANY_PROFILE.name;
  if (nth.type === COUNTRY_PROFILE_TYPE)
    ROUTE_NAME = ROUTES.COUNTRY_PROFILE.name;
  if (element === "Criticals Materials" || element === "Critical Materials")
    element = "CRITICAL_MATERIALS";

  let url = router.resolve({
    name: ROUTE_NAME,
    params: { id: nth.identity.uuid },
    query: { element },
  });

  if (nth.type === SUBSCRIPTION_FILES_PROFILE_TYPE) {
    url = router.resolve({
      name: nth.serviceType === COST_SERVICE_TYPE ? ROUTES.COST_ANALYSIS.name : ROUTES.FILES.name,
      query: { element: element },
    });
  }
  markAsRead(nth);
  router.push(url);
  closeDrawer();
};

const markAsRead = async (nth) => {
  await openNotification(nth.id);
  return (NOTIFICATIONS.value[NOTIFICATIONS.value.indexOf(nth)].isRead = true);
};

const invalidateAuthorization = () => {
  nextTick(async () => {
    await logout(router);
  });
};

const availableElements = computed(() => {
  const elements = new Set();
  unreadNotifications.value.forEach(n => {
    n.commodities?.forEach(el => elements.add(el));
  });
  return [...elements];
});

const filteredNotifications = computed(() => {
  if (!activeElementFilter.value) return unreadNotifications.value;
  return unreadNotifications.value.filter(n =>
      n.commodities?.includes(activeElementFilter.value)
  );
});

onMounted(async () => {
  await getNotifications();
});
</script>

<style scoped>
.element-filter-bar {
  padding: 0.6rem;
  background: #f2f2f2;
}

.custom-select {
  position: relative;
  width: 100%;
  font-size: 0.82rem;
}

.custom-select-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.45rem 0.75rem;
  background: white;
  border: 0;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.select-chevron {
  font-size: 0.7rem;
  color: #718096;
  transition: transform 0.2s ease;
}

.custom-select.open .select-chevron {
  transform: rotate(180deg);
}

.custom-select-dropdown {
  display: none;
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #dee2e6;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 220px;
  overflow-y: auto;
}

.custom-select.open .custom-select-dropdown {
  display: block;
}

.custom-select-option {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.55rem 0.75rem;
  cursor: pointer;
  transition: background 0.15s ease;
}

.custom-select-option:hover {
  background: #f5f5f5;
}

.custom-select-option.active {
  color: #00213b;
}

.custom-select-option.active .option-name {
  color: #00213b;
}

/*.option-symbol {
  font-size: 0.75rem;
  font-weight: 700;
  color: white;
  background: #00213b;
  padding: 0.1rem 0.4rem;
  min-width: 28px;
  text-align: center;
  letter-spacing: 0.03em;
}*/

.option-name {
  color: #333;
  font-weight: 500;
}
.option-name:active {
  color: #00213b;
}

/* Email Icon */
.notification-email-icon {
  flex-shrink: 0;
  display: flex;
  align-self: center;
  align-items: center;
  padding-left: 0.5rem;
}

.notification-email-icon i {
  color: #213ce5;
  font-size: 0.95rem;
  transition: opacity 0.2s ease;
}

/* Dismiss Icon */
.notification-dismiss-icon {
  flex-shrink: 0;
  display: flex;
  align-self: center;
  align-items: center;
  padding-left: 0.5rem;
  background: none;
  border: none;
  cursor: pointer;
  padding-right: 0;
}

.notification-dismiss-icon i {
  color: #a0aec0;
  font-size: 0.85rem;
  transition: color 0.2s ease;
}

.notification-dismiss-icon:hover i {
  color: #00213b;
}

/* Profile Toggle Button */
.profile-toggle {
  border: none !important;
  color: white;
  border-radius: 0 !important;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  margin: 0 !important;
  position: relative;
  overflow: hidden;
  background: transparent !important;
  box-shadow: none !important;
}

.profile-toggle:hover,
.profile-toggle:focus,
.profile-toggle.active {
  border: none !important;
  transform: scale(1.05);
}

.profile-icon-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Drawer Overlay - Below navbar */
.drawer-overlay {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
}

/* Drawer - Below Navbar from Right */
.profile-drawer {
  position: fixed;
  top: 70px;
  right: 0;
  width: 380px;
  height: calc(100vh - 70px);
  background: white;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.drawer-content {
  flex: 1;
  overflow-x: hidden;
  padding-bottom: 0.5rem;
  min-height: 0;
}

/* Sticky Logout Button */
.drawer-logout {
  flex-shrink: 0;
  border-top: 1px solid #e9ecef;
  background: white;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.5rem;
  color: #00213b;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: "GilroyBold", sans-serif;
  transition: background 0.2s ease, color 0.2s ease;
  cursor: pointer;
}

.logout-btn:hover {
  background: #f2f2f2;
}

.logout-btn .section-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* Accordion Sections */
.accordion-section {
  border-bottom: 1px solid #e9ecef;
}

.accordion-section:last-child {
  border-bottom: none;
}

.accordion-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  background: white;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  border-radius: 0;
}

.accordion-header:hover {
  background: #f8f9fa;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  span{
    font-family: "GilroyBold", sans-serif !important;
    font-size: 0.875rem;
  }
}

.header-left i {
  color: #213ce5;
  font-size: 0.875rem;
  width: 20px;
  text-align: center;
}
.section-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
}

.notification-badge,
.notes-badge {
  background: #213ce5;
  color: white;
  font-size: 0.7rem !important;
  padding: 0.02rem 0.3rem;
  border-radius: 10px;
  font-weight: 600;
}

.accordion-header .fa-chevron-down {
  color: #718096;
  font-size: 0.85rem;
  transition: transform 0.3s ease;
}

.accordion-header .fa-chevron-down.rotated {
  transform: rotate(180deg);
}

.accordion-content {
  padding: 0 1.25rem 1rem 1.25rem;
  background: white;

  &:has(.notifications-list) {
    padding: 0;
  }
  &:has(.card) {
    padding: 0;
  }
  &:has(.profile-info){
    padding: 0 1.25rem 0 1.25rem;
  }
}

/* Profile Section */
.profile-info {
  padding: 0.5rem 0;
}

.login-text {
  margin: 0;
  color: #000;
  font-size: 0.8125rem !important;
}

/* Quick Actions Section */
.quick-actions-content {
  :deep(p){
    font-size: 0.8125rem !important;
    color: #000;
  }
}

/* Notifications List */
.notifications-list-wrapper {
  max-height: 300px;
  overflow-y: auto;
}

.notifications-list {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.notification-item {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0 1.25rem 0 0.5rem;
  transition: background 0.2s ease;
  cursor: pointer;
  background: white;
}

.notification-item:hover {
  background: #f2f2f2;
}

.notification-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-icon .icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.notification-content {
  flex: 1;
  min-width: 0;
  align-self: center;
}

.notification-content h6 {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "GilroyMedium", sans-serif !important;
}

.notification-description {
  margin: 0;
  font-size: 0.8rem !important;
  color: #718096;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.notification-description i {
  font-size: 0.75rem;
}

.notes-timeline-wrapper {
  padding: 0.5rem 0;
}

.note-preview {
  font-size: 0.8rem;
  color: #718096;
  margin-top: 0.15rem;
}

/* Empty State */
.empty-state {
  padding: 2rem 1rem;
  text-align: center;
}

.empty-state p {
  color: #718096;
  font-size: 0.9rem;
  margin: 0;
}

/* Responsive */
@media (max-width: 767.98px) {
  .drawer-overlay {
    top: 60px;
  }

  .profile-drawer {
    top: 60px;
    width: 100%;
    max-width: 380px;
    height: calc(100vh - 60px);
  }
}

@media (max-width: 575.98px) {
  .profile-toggle {
    width: 36px;
    height: 36px;
  }

  .profile-icon-img {
    width: 32px;
    height: 32px;
  }

  .accordion-header {
    padding: 0.5rem;
  }

  .accordion-content {
    padding: 0 1rem 0.875rem 1rem;
  }

  .profile-drawer {
    width: 100%;
  }
}

/* Remove border-radius globally for this component */
* {
  border-radius: 0 !important;
}

/* But allow small radius for badges and action items */
.notification-badge,
.notes-badge {
  border-radius: 50% !important;
  min-width: 1.25rem;
  width: 1.25rem;
  height: 1.25rem;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  line-height: 1;
  box-sizing: border-box;
}

.notification-icon {
  border-radius: 10px !important;
}
</style>